import usePlacesAutocomplete, {getGeocode, getLatLng} from "use-places-autocomplete";
import React from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    root: {
        fontFamily: 'Roboto',
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: "16px!important",
        lineHeight: "24px",
        margin:"auto",
        color:'#9E9C9A',
        "& .Mui-focused": {
            color: "#808080",
            borderColor: "#D8D7D7",
        },
        "& .MuiOutlinedInput-root": {
            height:"54px",
            borderRadius:0,
            "&.Mui-focused fieldset": {
                borderColor: "#239FFF",
            }
        },
        "& .MuiInputLabel-marginDense" :{
            // transform:"translate(14px, 20px) scale(1);"
        }
    },
    label: {
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: '400',
        fontSize: '16px!important',
        lineHeight: '24px',
        color:'#9E9C9A',
    }
}));
export default function Search({
                                   placeholder,
                                    width,
                                   setMarkers,
                                   center,
                                   addressPosition,
                                   setAddressPosition,
                               }) {
    const {
        // ready,
        value,
        suggestions: {data},
        setValue,
        clearSuggestions,
    } = usePlacesAutocomplete({
        requestOptions: {
            location: {
                lat: () => center.lat,
                lng: () => center.lng
            },
            radius: 200 * 2000,
        },
    });
    const classes = useStyles();
    const handleInput = (e, newValue) => {
        if (!newValue) {
            setMarkers([])
        }
        setValue(newValue);
        setAddressPosition(newValue?.split(', ').join(', '))
    };

    const handleSelect = async (event, address) => {
        address = address?.description
        setValue(address, false);
        clearSuggestions();
        // setAddressPosition((address)?.split(',').join(', '))
        if (address) {
            try {
                const results = await getGeocode({address});
                const {lat, lng} = await getLatLng(results[0]);
                setMarkers([{lat, lng}])
                setAddressPosition((address)?.split(',').reverse().join(', '))
            } catch (error) {
                console.log("😱 Error: ", error);
            }
        }
    };
    return (<>
            <div>
                <Autocomplete
                    filterOptions={(x) => x}
                    freeSolo
                    className={classes.root}
                    style={{maxWidth:width}}
                    onChange={handleSelect}
                    value={value?.description}
                    inputValue={addressPosition || ''}
                    onInputChange={(event, newInputValue) => {
                        handleInput(event, newInputValue)
                    }}
                    options={data}
                    getOptionLabel={(option) =>
                        option.description || ''
                    }
                    renderInput={(params) => (
                        <TextField {...params} placeholder={placeholder} variant="outlined" className={classes.label}/>
                    )}
                />
            </div>
        </>
    );
}
